import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AosEditOnlineService } from './aos.editonline.service';
export class AosModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [],
  exports: [],
  providers: [
  	AosEditOnlineService
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AosModule_tsickle_Closure_declarations() {
/** @type {?} */
AosModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AosModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
